<template>
  <div class="flex-col list-info"
    :style="{height: 'calc(100% - '+h+'px)'}">
    <van-tabs v-model="active"
      type="card"
      style="height: 100%"
      @change="changeTab">
      <van-tab :title="$t('search.orgRelationship')"
        style="">
        <contractor-group-list :page-type="pageType"
          :is-edit="isEdit"
          id='contractor-list'
          ref="contractor"></contractor-group-list>
      </van-tab>
      <van-tab :title="$t('search.companyRelationship')">
        <contractor-group-list-company :page-type="pageType"
          :is-edit="isEdit"
          id='contractor-company-list'
          ref="contractorCompany"></contractor-group-list-company>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import ContractorList from "@components/content/contractor/ContractorList";
import ContractorGroupList from "@components/content/contractor/ContractorGroupList";
import ContractorListCompany from "@components/content/contractor/ContractorListCompany";
import ContractorGroupListCompany from "@components/content/contractor/ContractorGroupListCompany";
import scollerLocation from '@/common/scollerLocation';

import SearchPanel from "@components/common/SearchPanel";
import common from "@common/common";
import webService from "@network/webService";
export default {
  name: "SearchRelationshipList",
  data () {
    return {
      active: 0,
      isEdit: false,
      pageType: common.searchTypeEnum.relationCollect,
      h: 120,
      searchModel: '',
    };
  },
  components: {
    SearchPanel,
    ContractorList,
    ContractorListCompany,
    ContractorGroupList,
    ContractorGroupListCompany
  },
  activated () {
    scollerLocation.recoverLocation('contractor-list');
    scollerLocation.recoverLocation('contractor-company-list');
  },
  beforeRouteLeave (to, from, next) {
    var orgList = document.querySelector('#contractor-list .cont-list');
    if (orgList) {
      scollerLocation.saveLocation('contractor-list', orgList);
    }
    var companyList = document.querySelector('#contractor-company-list .cont-list');
    if (companyList) {
      scollerLocation.saveLocation('contractor-company-list', companyList);
    }
    next();
  },
  mounted () {
    this.$bus.$on("busfreshPwC", () => {
      this.getData(this.searchModel);
    });
  },
  methods: {
    changeTab () {
      this.$emit("relationtabChange", this.active);
    },
    changeH (num) {
      document.getElementsByClassName("list-info")[0].style.height =
        "calc(100% - " + num + "px)";
    },
    getData (searchModel) {
      this.searchModel = searchModel;
      this.h = 10;
      console.log("Tab:" + this.active);
      if (this.active == 1) {
        this.$refs.contractorCompany.getData(searchModel);
      } else {
        this.$refs.contractor.getData(searchModel);
      }
    },
    changeSearchValue (value) {
      if (this.active == 1) {
        this.$refs.contractorCompany.changeSearchValue(value);
      } else {
        this.$refs.contractor.changeSearchValue(value);
      }
    }
  },
};
</script>

<style lang='less' scoped>
.list-info {
  //   height: calc(100% - 120px);
  //padding: 10px 0 0 0;
}
/deep/ .van-tabs--card > .van-tabs__wrap {
  height: 36px;
  font-size: 0.875rem;
}
/deep/ .van-tabs__nav {
  height: 32px;
}
/deep/ .van-tabs__content {
  height: calc(100% - 30px);
}
/deep/ .van-tab {
  font-size: 12px;
}
/deep/ .van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #c52a1a;
  color: #ffffff;
}
/deep/ .van-tabs__nav--card .van-tab {
  color: #7d7d7d;
}
/deep/ .van-tabs__nav--card {
  border-color: #979797;
}
/deep/ .van-tab__pane {
  height: 100%;
}
/deep/ .van-tabs__nav--card .van-tab {
  border-right: 1px solid #c52a1a;
}
/deep/ .van-tabs__nav--card .van-tab:last-child {
  border-right: none;
}
</style>


// WEBPACK FOOTER //
// src/views/search/SearchRelationshipList.vue